// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2156":"f6cbda25","8839":"0a2c88dc"}[chunkId] + ".chunk.css";
};